import { render, staticRenderFns } from "./PlanCriterias.vue?vue&type=template&id=458be7d6&scoped=true"
import script from "./PlanCriterias.vue?vue&type=script&lang=js"
export * from "./PlanCriterias.vue?vue&type=script&lang=js"
import style0 from "./PlanCriterias.vue?vue&type=style&index=0&id=458be7d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458be7d6",
  null
  
)

export default component.exports